import { BROADCAST_SET_SERVER_DELTA } from 'actions/Types';

const initialState = 0;

function serverTimeDelta(state = initialState, action) {
  if (action.type === BROADCAST_SET_SERVER_DELTA) {
    return action.payload;
  }

  return state;
}

export default serverTimeDelta;
